<template>
    <el-select v-model="secili" value-key="label" class="mak-kontrol-filtre">
        <el-option
            v-for="(f, i) in filters"
            :key="`${i}.filter`"
            :label="f.label"
            :value="f">
        </el-option>
    </el-select>
</template>

<script>
    const FILTERS = [
        {
            label: 'Hepsi',
            filter: null,
        },
        {
            label: 'Yapılacak Kontroller',
            filter: d => !d.id,
        },
        {
            label: 'Zamanı Gecenler',
            filter: d => d.diff < 0 && !d.id,
        },
        {
            label: 'Bugun kontrole gidilecek',
            filter: d => d.diff === 0 && !d.id,
        },
        {
            label: 'Yaklasan Kontroller',
            filter: d => d.diff > 0 && !d.id,
        },
        {
            label: 'Biten Kontroller',
            filter: d => d.id,
        },
    ];

    export default {
        name: 'mak-kontrol-filtre',
        model: {
            props: 'value',
            event: 'change',
        },
        props: {
            value: { type: [Object, Function] },
        },
        data() {
            return {
                secili: FILTERS[0],
            };
        },
        computed: {
            filters() {
                return FILTERS;
            }
        },
        mounted() {
            this.$emit('change', this.secili);
        },
        watch: {
            secili() {
                this.$emit('change', this.secili);
            },
        },
    }
</script>

<style>
.mak-kontrol-filtre {
    min-width: 250px;
}
</style>